import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Heading, Paragraph } from '@zillow/constellation';
import EnrollmentTooltip from './EnrollmentTooltip';

export default function EnrollmentStatus({ enrollmentOn }) {
  const headingText = enrollmentOn ? 'Accepting Zillow applications' : 'Accept Zillow applications (FREE)';
  const bodyText = enrollmentOn
    ? 'You’ll receive applications with full credit & background check, powered by Experian and CIC.'
    : 'Zillow applications include full credit & background check, powered by Experian and CIC.';

  return (
    <Flex display="flex" flexDirection="column">
      <Heading level={6}>
        {headingText}
        <EnrollmentTooltip />
      </Heading>
      <Paragraph>{bodyText}</Paragraph>
    </Flex>
  );
}

EnrollmentStatus.propTypes = {
  enrollmentOn: PropTypes.bool,
};
